export const forms = {
  getFormData(formData, extend) {
    const data = [
      {
        type: 'input',
        label: '姓名',
        col: '10',
        id: 'user_nick_name',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: 'input',
        label: '账号',
        // onChange: extend.numberChange,
        col: '10',
        id: 'user_name',
        layout: {
          labelCol: '120px'
        }
      },
      // {
      //   type: 'select',
      //   label: '所属部门',
      //   col: '7',
      //   id: 'municipal_tree_id',
      //   options: [
      //     {
      //       label: '基金会',
      //       value: 1
      //     },
      //     {
      //       label: '区县',
      //       value: 2
      //     },
      //     {
      //       label: '街道',
      //       value: 3
      //     }
      //   ],
      //   layout: {
      //     labelCol: '120px'
      //   }
      // },
      {
        type: 'children',
        name: 'button',
        col: '4'
      }
    ]
    return data
  },
  getIdCard(extend) {
    const data = [
      {
        type: 'input',
        label: '新增人员身份证号',
        // onChange: extend.numberChange,
        placeholder: '请输入新增人员的身份证号',
        col: '8',
        rules: [
          {
            required: true,
            message: '身份证号不能为空'
          },
          {
            validator: extend.checkIdCard
          }
        ],
        id: 'idCard',
        layout: {
          labelCol: '150px'
        }
      },
      {
        type: 'children',
        name: 'button',
        col: '3'
      }
    ]
    return data
  }
}
